import { Controller } from "@hotwired/stimulus";
import { jsonHeaders } from "../utils";

// Connects to data-controller="item-share"
export default class extends Controller {
  static targets = ["option", "btn", "close", "copyWrapper"];
  static values = { url: String };

  connect() {
    this.btnTarget.disabled = false;
    this.closeTarget.style.display = "block";
  }

  submit(ev) {
    ev.preventDefault();

    console.log("submit");

    this.btnTarget.disabled = true;
    this.closeTarget.style.display = "none";

    // generate share link
    const data = {};
    this.optionTargets.forEach((el) => {
      data[el.dataset.name] = el.checked;
    });

    fetch(this.element.action, {
      method: "PUT",
      headers: jsonHeaders(),
      body: JSON.stringify({ project: { view_permissions: data } }),
    })
      .then((resp) => {
        if (resp.ok) {
          resp.json().then((body) => {
            window.notyf.success("View permissions updated!");

            const modal = bootstrap.Modal.getInstance("#bsTurboModal");
            modal.hide();
          });
        }
      })
      .catch((err) => console.log(err));
  }
}
